export const CREATIVE_STATUSES = [
  { id: 1, name: "Active",   color: "#F90091" },
  { id: 3, name: "Inactive", color: "#555555" },
];

export function statusById(id) {
  return CREATIVE_STATUSES.find((s) => s.id === id) || null;
}
